import { Controller } from '@hotwired/stimulus'
import { listReturn } from '@/lib/list-return'

export default class extends Controller<HTMLAnchorElement> {
  override connect() {
    const href = this.element.getAttribute('href')
    if (href) this.element.setAttribute('href', listReturn(href))
  }
}
